/**
 * Destinations and helpers shared by call-to-action buttons across the site.
 */

export const APP_URL = "https://app.axy.digital";

/**
 * Calendly booking destinations, one per event type. Every CTA must reference
 * one of these rather than inlining a `calendly.com` URL — the event type
 * determines which intake questions and round-robin the lead lands in.
 */
export const CALENDLY_30MIN_URL = "https://calendly.com/robinlim/30min";
/** Demo for direct (non-agency) prospects — `/lp/schedule`. */
export const CALENDLY_DEMO_URL = "https://calendly.com/robinlim/axy-digital-demo";
/** Demo for agency prospects — `/lp/schedule-agency`. */
export const CALENDLY_DEMO_AGENCY_URL = "https://calendly.com/robinlim/axy-digital-demo-clone";

/** Builds the standard landing-page UTM query for app links. */
function utm(source_page: string): string {
  return `utm_source=landing&lp=${encodeURIComponent(source_page)}`;
}

/** Sign-up URL for "start for free" CTAs. `source` identifies the originating CTA. */
export function signUpUrl(source: string): string {
  return `${APP_URL}/sign-up?${utm(source)}`;
}

/** Sign-in URL for the header "Sign in" CTA. */
export function signInUrl(source: string): string {
  return `${APP_URL}/sign-in?${utm(source)}`;
}

/** Website-preview URL — scans the given site and previews what Axy.digital would do. */
export function previewUrl(website: string, source: string): string {
  return `${APP_URL}/en/preview?website=${encodeURIComponent(website)}&${utm(source)}`;
}

/** Smooth-scrolls to a section by element id (used by "see how it works" CTAs). */
export function scrollToSection(id: string): void {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}
